/* HydratBath — np-product.js
   Gallerij, staffelprijzen, extra opties en toevoegen aan winkelwagen.
   Na toevoegen opent de winkelwagen-lade (dn-cart-drawer.js) in plaats van /cart.
   Geen externe libraries. */
(function () {
  'use strict';

  document.querySelectorAll('[data-np-product]').forEach(init);

  function init(root) {
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'nl-NL';
    var afterAdd = root.dataset.cartAction || 'cart';

    var fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    function money(cents) { return fmt.format((cents || 0) / 100); }

    /* ---------- Varianten ---------- */
    var variants = [];
    var raw = root.querySelector('[data-np-variants]');
    if (raw) { try { variants = JSON.parse(raw.textContent) || []; } catch (e) { variants = []; } }

    function variantById(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    var baseSelect = root.querySelector('[data-np-base-variant]');

    function basePrice() {
      if (baseSelect) {
        var v = variantById(baseSelect.value);
        if (v) return v.price;
      }
      if (variants.length) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) return variants[i].price;
        }
        return variants[0].price;
      }
      return 0;
    }

    function baseVariantId() {
      if (baseSelect && baseSelect.value) return baseSelect.value;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i].id;
      }
      return variants.length ? variants[0].id : null;
    }

    /* ---------- Gallerij ---------- */
    root.querySelectorAll('[data-np-gallery]').forEach(function (gal) {
      var vp = gal.querySelector('[data-np-gallery-viewport]');
      var slides = gal.querySelectorAll('.np-gallery__slide');
      var dotWrap = gal.querySelector('[data-np-gallery-dots]');
      var thumbs = gal.querySelectorAll('[data-np-gallery-goto]');
      if (!vp || slides.length < 2) { if (dotWrap) dotWrap.remove(); return; }

      var dots = [];
      if (dotWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'np-gallery__dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Afbeelding ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotWrap.appendChild(b);
          dots.push(b);
        });
      }

      function goTo(i) { vp.scrollTo({ left: vp.clientWidth * i, behavior: 'smooth' }); }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.npGalleryGoto, 10)); });
      });

      var raf;
      vp.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(vp.scrollLeft / vp.clientWidth);
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        });
      });
    });

    /* ---------- Staffels en extra opties ---------- */
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-np-tier]'));
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-np-addon]'));

    function selectedTier() {
      for (var i = 0; i < tiers.length; i++) { if (tiers[i].checked) return tiers[i]; }
      if (tiers.length) { tiers[0].checked = true; return tiers[0]; }
      return null;
    }

    function unitSelectsFor(tier) {
      var label = tier.closest('.np-tier');
      return label ? Array.prototype.slice.call(label.querySelectorAll('[data-np-unit-variant]')) : [];
    }

    function tierSubtotal(tier) {
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var pct = parseFloat(tier.dataset.discount) || 0;
      var selects = unitSelectsFor(tier);
      var gross = 0;
      if (selects.length === qty) {
        selects.forEach(function (s) {
          var v = variantById(s.value);
          gross += v ? v.price : basePrice();
        });
      } else {
        gross = basePrice() * qty;
      }
      return { gross: gross, net: Math.round(gross * (1 - pct / 100)) };
    }

    function addonsTotal() {
      var sum = 0;
      addons.forEach(function (a) {
        if (a.checked) sum += parseInt(a.dataset.price, 10) || 0;
      });
      return sum;
    }

    function render() {
      // Prijs per staffelkaart
      tiers.forEach(function (t) {
        var box = t.closest('.np-tier');
        var sub = tierSubtotal(t);
        var priceEl = box.querySelector('[data-np-tier-price]');
        var compEl = box.querySelector('[data-np-tier-compare]');
        if (priceEl) priceEl.textContent = money(sub.net);
        if (compEl) compEl.textContent = money(sub.gross);
      });

      // Losse prijsregel
      var unitEl = root.querySelector('[data-np-unit-price]');
      if (unitEl && baseSelect) {
        var v = variantById(baseSelect.value);
        if (v) {
          unitEl.textContent = money(v.price);
          var cmpEl = root.querySelector('[data-np-unit-compare]');
          if (cmpEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              cmpEl.textContent = money(v.compare_at_price);
              cmpEl.hidden = false;
            } else {
              cmpEl.hidden = true;
            }
          }
        }
      }

      // Totaal
      var totalEl = root.querySelector('[data-np-total]');
      if (totalEl) {
        var t = selectedTier();
        var base = t ? tierSubtotal(t).net : basePrice();
        totalEl.textContent = money(base + addonsTotal());
      }
    }

    tiers.forEach(function (t) { t.addEventListener('change', render); });
    addons.forEach(function (a) { a.addEventListener('change', render); });
    if (baseSelect) baseSelect.addEventListener('change', render);
    root.querySelectorAll('[data-np-unit-variant]').forEach(function (s) {
      s.addEventListener('change', render);
    });
    render();

    /* ---------- Toevoegen aan winkelwagen ---------- */
    var addBtn = root.querySelector('[data-np-add]');
    var errEl = root.querySelector('[data-np-error]');
    if (!addBtn) return;

    function showError(msg) {
      if (!errEl) { alert(msg); return; }
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    addBtn.addEventListener('click', function () {
      if (errEl) errEl.hidden = true;

      var items = [];
      var tier = selectedTier();

      if (tier) {
        var qty = parseInt(tier.dataset.qty, 10) || 1;
        var selects = unitSelectsFor(tier);
        if (selects.length === qty) {
          var counts = {};
          selects.forEach(function (s) { counts[s.value] = (counts[s.value] || 0) + 1; });
          Object.keys(counts).forEach(function (id) {
            items.push({ id: Number(id), quantity: counts[id] });
          });
        } else {
          var bid = baseVariantId();
          if (!bid) { showError('Kies eerst een variant.'); return; }
          items.push({ id: Number(bid), quantity: qty });
        }
      } else {
        var only = baseVariantId();
        if (!only) { showError('Dit product is niet beschikbaar.'); return; }
        items.push({ id: Number(only), quantity: 1 });
      }

      addons.forEach(function (a) {
        var vid = a.dataset.variant;
        if (a.checked && vid) items.push({ id: Number(vid), quantity: 1 });
      });

      addBtn.classList.add('is-loading');
      var labelEl = addBtn.querySelector('[data-np-add-label]');
      var oldLabel = labelEl ? labelEl.textContent : '';
      if (labelEl) labelEl.textContent = 'Bezig…';

      function resetButton() {
        addBtn.classList.remove('is-loading');
        if (labelEl) labelEl.textContent = oldLabel;
      }

      var code = tier ? (tier.dataset.code || '') : '';

      // Nieuw: lade openen in plaats van naar /cart te gaan.
      // De bundelkorting komt automatisch uit de Rapi Quantity Breaks-app,
      // dus hier wordt geen kortingscode meegestuurd.
      if (afterAdd !== 'checkout' && window.DNCart && typeof window.DNCart.add === 'function') {
        window.DNCart.add(items)
          .then(resetButton)
          .catch(function (e) {
            resetButton();
            showError((e && e.message) || 'Er ging iets mis. Probeer het opnieuw.');
          });
        return;
      }

      // Oude route: direct afrekenen (of noodroute als de lade ontbreekt)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Toevoegen mislukt.');
          var dest = afterAdd === 'checkout' ? '/checkout' : '/cart';
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest)
            : dest;
        })
        .catch(function (e) {
          resetButton();
          showError(e.message || 'Er ging iets mis. Probeer het opnieuw.');
        });
    });
  }
})();
